import customCellComponents from '../components/custom-cell-components/customCellComponents';

import { formatMDYWithParam } from 'utils/formatDate';

const formatFieldsName = (jsonConfig) => {
  let fieldsName = [];

  if (jsonConfig) {
    const config = JSON.parse(jsonConfig);

    config.columns.forEach((column) => {
      if (column.fieldFullPath === 'brandName') return;
      fieldsName.push({
        fieldName: column.fieldFullPath,
      });
    });
  }

  return fieldsName;
};

const normalizeDataType = (dataType) => {
  const lower = dataType?.toLowerCase();
  return lower === 'bool' ? 'boolean' : lower;
};

const formatColumns = (jsonConfig) => {
  let cols = [
    {
      filter: false,
      suppressHeaderMenuButton: true,
      resizable: true,
      checkboxSelection: true,
    },
  ];

  if (jsonConfig) {
    const config = JSON.parse(jsonConfig);

    config.columns.forEach((column) => {
      const { fieldFullPath, dataType, displayName, minWidth, width, field } =
        column || {};

      if (fieldFullPath === 'brandName') return;
      const headerMinWidth = fieldFullPath === 'ownerName' ? 220 : 200;

      let formattedFieldFullPath = fieldFullPath;

      if (fieldFullPath.includes('CustomFields')) {
        formattedFieldFullPath = fieldFullPath.replace(
          /^CustomFields\./,
          'customFields.'
        );
      }

      if (fieldFullPath === 'productName') {
        cols.push({
          allowFilter: true,
          allowSort: true,
          resizable: true,
          dataType: normalizeDataType(dataType),
          field: formattedFieldFullPath,
          headerName: displayName,
          linkTo: '/product/{id}',
          minWidth: Math.max(Number(minWidth) || 0, 300),
          width: width,
        });
      } else if (dataType?.toLowerCase() === 'datetime') {
        cols.push({
          field: formattedFieldFullPath,
          headerName: displayName,
          minWidth: Math.max(Number(minWidth) || 0, headerMinWidth),
          width: width,
          cellRenderer: formatMDYWithParam,
        });
      } else if (field === 'stateIcons') {
        cols.push({
          ...column,
          field: formattedFieldFullPath,
          headerName: 'States',
          minWidth: minWidth,
          width: width,
          cellRenderer: customCellComponents.renderIcons,
        });
      } else if (field === 'productThumbnail') {
        cols.push({
          ...column,
          dataType: normalizeDataType(dataType),
          field: formattedFieldFullPath,
          headerName: displayName,
          minWidth: minWidth,
          width: width,
          cellRenderer: customCellComponents.renderThumbnail,
        });
      } else {
        cols.push({
          allowFilter: true,
          allowSort: true,
          resizable: true,
          dataType: normalizeDataType(dataType),
          field: formattedFieldFullPath,
          headerName: displayName,
          minWidth: Math.max(Number(minWidth) || 0, headerMinWidth),
          width: width,
          ...((fieldFullPath === 'isIxOneCertified' ||
            fieldFullPath === 'isTcpProduct') && {
            allowBooleanSort: true,
            filter: true,
          }),
        });
      }
    });
  }

  return cols;
};

export { formatColumns, formatFieldsName };
